import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var GoogleWalletLightS = function GoogleWalletLightS(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 64,
    height: 28,
    viewBox: "0 0 64 28",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GoogleWalletLightS_svg__GoogleWalletLightS_svg__clip0_18246_92364)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.505 6.228v6.242h3.876c.923 0 1.687-.308 2.29-.925.62-.614.931-1.348.931-2.197 0-.831-.31-1.556-.93-2.172-.604-.632-1.368-.95-2.291-.95h-3.876v.002zm0 8.44v7.24h-2.316V4.03h6.142c1.56 0 2.885.517 3.976 1.548 1.108 1.032 1.661 2.289 1.661 3.77 0 1.515-.554 2.78-1.66 3.794-1.075 1.016-2.401 1.523-3.977 1.523h-3.826v.001zm11.803 3.494c0 .6.256 1.099.768 1.498.512.4 1.112.6 1.8.6.973 0 1.84-.359 2.604-1.074.764-.716 1.145-1.556 1.145-2.52-.722-.567-1.73-.85-3.02-.85-.941 0-1.725.226-2.353.675-.629.45-.944 1.005-.944 1.671zm2.996-8.888c1.711 0 3.062.454 4.053 1.361.99.907 1.484 2.151 1.484 3.732v7.54h-2.215V20.21h-.1c-.957 1.398-2.233 2.098-3.826 2.098-1.36 0-2.497-.4-3.41-1.199-.915-.799-1.372-1.797-1.372-2.996 0-1.265.482-2.271 1.447-3.02.965-.75 2.252-1.124 3.863-1.124 1.374 0 2.508.25 3.397.749v-.525c0-.8-.32-1.477-.957-2.035a3.295 3.295 0 00-2.239-.836c-1.293 0-2.315.54-3.07 1.624l-2.04-1.274c1.125-1.598 2.786-2.397 4.985-2.397zm18.246.399L55.823 27.3h-2.39l2.869-6.168-5.084-11.459h2.517l3.674 8.789h.05l3.574-8.789h2.517z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.149 13.106c0-.723-.062-1.42-.179-2.088h-9.765v3.956h5.593a4.754 4.754 0 01-2.068 3.121v2.57h3.338c1.955-1.79 3.08-4.433 3.08-7.559z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.205 23.144c2.794 0 5.147-.91 6.863-2.48l-3.338-2.569c-.93.62-2.126.983-3.525.983-2.7 0-4.993-1.806-5.813-4.24H1.953v2.646a10.364 10.364 0 009.252 5.66z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.392 14.838a6.128 6.128 0 010-3.932V8.26H1.953A10.15 10.15 0 00.85 12.872c0 1.66.398 3.226 1.103 4.613l3.439-2.647z",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.205 6.666c1.526 0 2.894.52 3.972 1.54v.002l2.956-2.931C16.338 3.619 13.998 2.6 11.205 2.6a10.364 10.364 0 00-9.252 5.66l3.439 2.646c.82-2.434 3.112-4.24 5.813-4.24z",
    fill: "#E94235"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GoogleWalletLightS_svg__GoogleWalletLightS_svg__clip0_18246_92364"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h64v28H0z"
  }))));
};
export default GoogleWalletLightS;